import {
  GET_CATEGORIES_PENDING,
  GET_CATEGORIES_SUCCESS,
  GET_CATEGORIES_FAIL,
  GET_BRANDS_PENDING,
  GET_BRANDS_SUCCESS,
  GET_BRANDS_FAIL,
  GET_HIERARCHY_CATEGORIES_PENDING,
  GET_HIERARCHY_CATEGORIES_SUCCESS,
  GET_HIERARCHY_CATEGORIES_FAIL,
  GET_GROUP_CATEGORIES_PENDING,
  GET_GROUP_CATEGORIES_SUCCESS,
  GET_GROUP_CATEGORIES_FAIL,
  GET_CATEGORY_ATTRIBUTES_PENDING,
  GET_CATEGORY_ATTRIBUTES_SUCCESS,
  GET_CATEGORY_ATTRIBUTES_FAIL,
  GET_EXCHANGE_RATES_PENDING,
  GET_EXCHANGE_RATES_SUCCESS,
  GET_EXCHANGE_RATES_FAIL,
  SET_CATEGORY_ID,
  CLEAR_CATEGORY_ATTRIBUTES,
} from "./mutation-types";

export default {
  [GET_CATEGORIES_PENDING](state) {
    state.isLoading.categories = true;
    state.errors.categories = null;
  },
  [GET_CATEGORIES_SUCCESS](state, categories) {
    state.isLoading.categories = false;
    state.categories = categories || [];
    state.errors.categories = null;
  },
  [GET_CATEGORIES_FAIL](state, error) {
    state.isLoading.categories = false;
    state.errors.categories = error;
  },

  [GET_BRANDS_PENDING](state) {
    state.isLoading.brands = true;
    state.errors.brands = null;
  },
  [GET_BRANDS_SUCCESS](state, brands) {
    state.isLoading.brands = false;
    state.brands = brands || [];
    state.errors.brands = null;
  },
  [GET_BRANDS_FAIL](state, error) {
    state.isLoading.brands = false;
    state.errors.brands = error;
  },

  [GET_HIERARCHY_CATEGORIES_PENDING](state) {
    state.isLoading.hierarchyCategories = true;
    state.errors.hierarchyCategories = null;
  },
  [GET_HIERARCHY_CATEGORIES_SUCCESS](state, categories) {
    state.isLoading.hierarchyCategories = false;
    state.hierarchyCategories = categories || [];
    state.errors.hierarchyCategories = null;
  },
  [GET_HIERARCHY_CATEGORIES_FAIL](state, error) {
    state.isLoading.hierarchyCategories = false;
    state.errors.hierarchyCategories = error;
  },

  [GET_GROUP_CATEGORIES_PENDING](state) {
    state.isLoading.groupCategories = true;
    state.errors.groupCategories = null;
  },
  [GET_GROUP_CATEGORIES_SUCCESS](state, categories) {
    state.isLoading.groupCategories = false;
    state.groupCategories = categories || [];
    state.errors.groupCategories = null;
  },
  [GET_GROUP_CATEGORIES_FAIL](state, error) {
    state.isLoading.groupCategories = false;
    state.errors.groupCategories = error;
  },

  [GET_CATEGORY_ATTRIBUTES_PENDING](state) {
    state.isLoading.categoryAttributes = true;
    state.errors.categoryAttributes = null;
  },
  [GET_CATEGORY_ATTRIBUTES_SUCCESS](state, { categoryId, attributes }) {
    state.isLoading.categoryAttributes = false;
    state.categoryAttributes = {
      ...state.categoryAttributes,
      [categoryId]: attributes,
    };
    state.errors.categoryAttributes = null;
  },
  [GET_CATEGORY_ATTRIBUTES_FAIL](state, error) {
    state.isLoading.categoryAttributes = false;
    state.errors.categoryAttributes = error;
  },

  [GET_EXCHANGE_RATES_PENDING](state) {
    state.isLoading.exchangeRates = true;
    state.errors.exchangeRates = null;
  },
  [GET_EXCHANGE_RATES_SUCCESS](state, rates) {
    state.isLoading.exchangeRates = false;
    state.exchangeRates = rates;
    state.errors.exchangeRates = null;
  },
  [GET_EXCHANGE_RATES_FAIL](state, error) {
    state.isLoading.exchangeRates = false;
    state.errors.exchangeRates = error;
  },

  [SET_CATEGORY_ID](state, categoryId) {
    state.selectedCategoryId = categoryId;
  },

  [CLEAR_CATEGORY_ATTRIBUTES](state) {
    state.categoryAttributes = {};
  },
};
